import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TextModes } from '../../../components/ui/controls/text-input/text-input.component';
import { RecurringSchedule } from '../../../models/recurringPayments/recurringSchedule';
import { suggestAlignedDates } from '../../../models/recurringPayments/helpers';
import { ListItem } from '../../../../../../../libs/Shared/components/model/listItem';

@Component({
  selector: 'app-terminal-recurring-form',
  templateUrl: './terminal-recurring-form.component.html',
  standalone: false,
})
export class TerminalRecurringFormComponent {
  @Input() paymentExpMonth: string | undefined;
  @Input() paymentExpYear: string | undefined;
  @Input({ required: true }) recurringSchedule!: RecurringSchedule;
  @Output() recurringScheduleChange = new EventEmitter<RecurringSchedule>();

  inputTextModes = TextModes;
  frequencyTypeOptions: ListItem[] = [];
  chargeUntilOptions: ListItem[] = [];

  suggestedEndDateBeforeToDisplay: string | undefined;
  suggestedEndDateBefore: Date | undefined;
  suggestedEndDateAfterToDisplay: string | undefined;
  suggestedEndDateAfter: Date | undefined;

  chargetUntilCancelled: boolean = false;
  chargetUntilDate: Date | undefined;
  chargetUntilNumberOfCharges: number | undefined;

  constructor() {
    this.frequencyTypeOptions.push(new ListItem({ id: 'day', name: 'day' }));
    this.frequencyTypeOptions.push(new ListItem({ id: 'week', name: 'week' }));
    this.frequencyTypeOptions.push(
      new ListItem({ id: 'month', name: 'month' }),
    );
    this.frequencyTypeOptions.push(new ListItem({ id: 'year', name: 'year' }));

    //this.chargeUntilOptions.push(new ListItem({id: "expires", name:"Card expires"}));
    this.chargeUntilOptions.push(
      new ListItem({ id: 'cancelled', name: 'Cancelled' }),
    );
    this.chargeUntilOptions.push(
      new ListItem({ id: 'date', name: 'A specific date' }),
    );
    this.chargeUntilOptions.push(
      new ListItem({ id: 'number', name: 'Number of payments' }),
    );
  }

  ngOnInit() {
    if (this.paymentExpYear?.length == 2) {
      this.paymentExpYear = '20' + this.paymentExpYear;
    }
  }

  useSuggestedEndDateBefore() {
    if (this.suggestedEndDateBefore == undefined) {
      return;
    }

    this.recurringSchedule.finalChargeDate =
      this.suggestedEndDateBefore.toISOString();
    this.suggestedEndDateBefore = undefined;
    this.suggestedEndDateAfter = undefined;
    this.handleFormChanged();
  }

  useSuggestedEndDateAfter() {
    if (this.suggestedEndDateAfter == undefined) {
      return;
    }
    this.recurringSchedule.finalChargeDate =
      this.suggestedEndDateAfter.toISOString();

    this.suggestedEndDateBefore = undefined;
    this.suggestedEndDateAfter = undefined;

    this.handleFormChanged();
  }

  handleFormChanged() {

    if (this.isRecurringScheduleValid()) {
      this.suggestedEndDateBefore = undefined;
      this.suggestedEndDateAfter = undefined;

      if (
        this.recurringSchedule.firstChargeDate != undefined &&
        this.recurringSchedule.finalChargeDate != undefined &&
        this.recurringSchedule.period != undefined &&
        this.recurringSchedule.periodCount != undefined &&
        this.recurringSchedule.periodCount > 0
      ) {
        const res = suggestAlignedDates({
          startYMD: this.recurringSchedule.firstChargeDate,
          chosenEndYMD: this.recurringSchedule.finalChargeDate,
          period: this.recurringSchedule.period,
          frequency: this.recurringSchedule.periodCount,
        });

        if (res.alignedDate != null) {
          // this means the chosen end date is valid for the schedule
          this.suggestedEndDateBefore = undefined;
          this.suggestedEndDateAfter = undefined;
          this.suggestedEndDateBeforeToDisplay = undefined;
          this.suggestedEndDateAfterToDisplay = undefined;
        } else {
          if (res.previousDate != null) {
            this.suggestedEndDateBefore = res.previousDate;
            this.suggestedEndDateBeforeToDisplay =
              this.formatDateForRecurringSchedule(this.suggestedEndDateBefore);
          }
          if (res.nextDate != null) {
            this.suggestedEndDateAfter = res.nextDate;
            this.suggestedEndDateAfterToDisplay =
              this.formatDateForRecurringSchedule(this.suggestedEndDateAfter);
          }
        }
      }
    }

    this.recurringScheduleChange.emit(this.recurringSchedule);
  }

  public clear() {
    const cleared = new RecurringSchedule({});
    this.suggestedEndDateBefore = undefined;
    this.suggestedEndDateAfter = undefined;
    this.suggestedEndDateBeforeToDisplay = undefined;
    this.suggestedEndDateAfterToDisplay = undefined;
    this.recurringScheduleChange.emit(cleared);
  }

  isRecurringScheduleValid(): boolean {
    return (
      this.recurringSchedule.period != undefined &&
      (this.recurringSchedule.period == 'day' ||
        this.recurringSchedule.period == 'week' ||
        this.recurringSchedule.period == 'month' ||
        this.recurringSchedule.period == 'year') &&
      this.recurringSchedule.chargeUntil != undefined &&
      ((this.recurringSchedule.chargeUntil == 'date' &&
        this.recurringSchedule.finalChargeDate != undefined) ||
        (this.recurringSchedule.chargeUntil == 'number' &&
          this.recurringSchedule.numberOfCharges != undefined) ||
        this.recurringSchedule.chargeUntil == 'cancelled') &&
      (this.recurringSchedule.periodCount != undefined ||
        this.recurringSchedule.numberOfCharges != undefined)
    );
  }

  formatDateForRecurringSchedule(date: Date): string {
    return (
      date.toLocaleString('default', { month: 'long' }) +
      ' ' +
      date.getDate() +
      ', ' +
      date.getFullYear()
    );
  }
}
